export default __webpack_public_path__ + "static/media/blank.c29d635b.jpg";